import React, { useMemo } from "react";
import { HStack, Icon, Menu, MenuItem, MenuList, Text } from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";

import { CURRENCIES } from "../../balanceSheetConstants";
import {
  getRangeOptions,
  isCustomRangeValue,
} from "../../Shared/Utils/dateRanges";
import { ReportMenuButton } from "../../Shared/Components/ReportMenuButton";
import { reportToolbarStyles } from "../../Shared/Styles/reportToolbarStyles";
import MainFilterPopover from "./MainFilterPopover";

export default function ProfitAndLossFilters({
  currentCurrency,
  currentRange,
  filters,
  onCurrencyChange,
  onSelectRange,
  onOpenCustomRange,
  onApplyFilters,
  texts,
}) {
  const isRTL = texts.en === "Arabic";
  const selectedCurrency =
    CURRENCIES.find((currency) => currency.code === currentCurrency) ||
    CURRENCIES[1];
  const rangeOptions = useMemo(() => getRangeOptions(texts), [texts]);

  return (
    <HStack
      spacing={1}
      overflow="hidden"
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
    >
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text fontSize="xs">
              {texts.reports?.figuresIn || "Figures in"}{" "}
              {selectedCurrency.label}
            </Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList
          {...reportToolbarStyles.menuList}
          maxHeight="150px"
          overflowY="auto"
          zIndex={2000}
        >
          {CURRENCIES.map((currency) => (
            <MenuItem
              key={currency.code}
              onClick={() => onCurrencyChange(currency.code)}
              fontWeight={currency.code === currentCurrency ? "bold" : "normal"}
              py={1}
              fontSize="xs"
            >
              {currency.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Menu>
        <ReportMenuButton>
          <HStack spacing={2}>
            <Text fontSize="xs">{currentRange}</Text>
            <Icon as={FaChevronDown} />
          </HStack>
        </ReportMenuButton>
        <MenuList {...reportToolbarStyles.menuList} zIndex={2000}>
          {rangeOptions.map((range) => (
            <MenuItem
              key={range.value}
              onClick={() =>
                isCustomRangeValue(range.value)
                  ? onOpenCustomRange()
                  : onSelectRange(range.value)
              }
              py={1}
              fontSize="xs"
            >
              {range.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <MainFilterPopover
        initialFilters={filters}
        onApplyFilters={onApplyFilters}
        texts={texts}
        isRTL={isRTL}
      />
    </HStack>
  );
}
